import React from 'react'
import ReportsMainHeaderOne from './ReportsMainHeaderOne'

const ReportsMainHeader = ({data}) => {
    return (
        <>
            <ReportsMainHeaderOne data={data}/>
        </>
    )
}

export default ReportsMainHeader;